import { IOrderProduct } from '../orderProduct';
import { IUser } from './user';

/**
 * Model definition for Order
 */
export interface IOrder {
  id: number;
  user?: IUser;
  date: Date;
  name: string;
  surname: string;
  city: string;
  address: string;
  productsWithQuantity: IOrderProduct[];
  state: IOrderState;
  deliveryDate?: Date;
  shippingCosts?: number;
  note?: string;
}

export enum IOrderState {
  new = 'new',
  delivering = 'delivering',
  completed = 'completed',
}
